import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '@chilecompra/react-kit/components'
import { putCookie } from '@chilecompra/react-kit/storages'
import {
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  isLocalEnv
} from '../../config/settings/environment'
import { useAccessToken } from '../../modules/hooks/security'
import { Root } from './ProtectByAccessToken.styles'

/**
 * The ProtectByAccessToken's container.
 *
 * TODO: this component will be remove it after handling proper checking of the access token with the server.
 */
const ProtectByAccessToken = props => {
  const { children, fallback } = props
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const accessToken = useAccessToken()

  useEffect(() => {
    if (!accessToken) {
      return setError(true)
    }

    putCookie(REACT_APP_ACCESS_TOKEN_NAME, accessToken)
    setLoading(false)
  }, [accessToken])

  if (!accessToken && !isLocalEnv) {
    window.location.href = REACT_APP_MERCADO_PUBLICO_BASE_URL
    return null
  }

  if (!error && loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  if (error) {
    return fallback()
  }

  return <>{children}</>
}

ProtectByAccessToken.defaultProps = {
  fallback: () => null
}
ProtectByAccessToken.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func
}

export default ProtectByAccessToken
